<script setup lang="ts">
const router = useRouter();

const prop = defineProps({
    news: { default: {}, type: [Object] },
    location: { default: {}, type: [Object] },
})
const goLink = (item: Object) => {
    router.push(`/regions/${item.branch_office_slug}/${item.slug}`);
};


</script>

<template>
  <div class="section news" v-if="news && news.length > 0">
    <div class="news__title title">Интересное в {{location.item.searchResult.pick_up_location_name.caption}}</div>
    <div class="news__swiper">
      <Swiper 
      :slides-per-view="3"
      :loop="true"
      :modules="[]"
      >
        <SwiperSlide v-for="(item, index) in news" :key="index">
          <div class="news__item small" @click="goLink(item)">
            <div class="news__item-image">
            <img :src="`https://mycarrental.ru/${item.image}`" alt="" v-if="item.image">
            <img src="/img/gallery-3.jpg" alt="" v-else>
            </div>
            <div class="news__item-content">
              <div v-if="item.formatted_date" class="news__item-label">{{item.formatted_date}}</div>
              <div v-if="item.title" class="news__item-title"><a href="javascript:void(0)">{{item.title}}</a></div>
              <div v-if="item.teaser" class="news__item-text">{{item.seo_description}}</div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      <!-- <div class="swiper-nav">
          <div class="swiper-button swiper-button-prev js-news-prev swiper-button-disabled" tabindex="-1" role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-cf48ba3b83da110b7" aria-disabled="true"></div>
          <div class="swiper-button swiper-button-next js-news-next" tabindex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-cf48ba3b83da110b7" aria-disabled="false"></div>
      </div> -->
    </div>
  </div>
</template>